export default "__VITE_ASSET__DQGh3Nt2__"